//export default '<%#= Rails.application.secrets.sentry_dsn %>'
// TODO probably not ideal to have this hard coded but the above no longer works
export default 'https://f3a1344a66274b20be81393eb4bbc717@o102465.ingest.sentry.io/225231'